// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DropdownWithLabel-wrapper [class*=contextMenuWrapper] {
  z-index: 1;
}
.DropdownWithLabel-wrapper .DropdownWithLabel-button {
  display: flex;
  align-items: center;
  column-gap: 8px;
  padding: 2px 0;
}
.DropdownWithLabel-wrapper .DropdownWithLabel-button .DropdownWithLabel-label {
  font-size: 14px;
  font-weight: 400;
  color: var(--color_neutral_500);
}
.DropdownWithLabel-wrapper .DropdownWithLabel-button .DropdownWithLabel-selected {
  font-size: 14px;
  font-weight: 700;
  color: var(--color_neutral_800);
}`, "",{"version":3,"sources":["webpack://./src/components/DropdownWithLabel/styles.scss"],"names":[],"mappings":"AACE;EACE,UAAA;AAAJ;AAGE;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,cAAA;AADJ;AAGI;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AADN;AAII;EACE,eAAA;EACA,gBAAA;EACA,+BAAA;AAFN","sourcesContent":[".DropdownWithLabel-wrapper {\n  [class*=\"contextMenuWrapper\"] {\n    z-index: 1;\n  }\n  \n  .DropdownWithLabel-button {\n    display: flex;\n    align-items: center;\n    column-gap: 8px;\n    padding: 2px 0;\n    \n    .DropdownWithLabel-label {\n      font-size: 14px;\n      font-weight: 400;\n      color: var(--color_neutral_500);\n    }\n\n    .DropdownWithLabel-selected {\n      font-size: 14px;\n      font-weight: 700;\n      color: var(--color_neutral_800);\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
